export const uploadPeer = {
    "arm": {
        tr_sucsessfullySent: "Ֆայլը հաջողությամբ ուղարկվեց",
        tr_error: "Սխալմունք, փորձեք կրկին",
        tr_pleaseWait: "Խնդրում ենք սպասել ...",
        tr_isntOnline: "Օգտատերը հասանելի չէ",
        tr_connectedWith(user){
            return `Դուք կապի մեջ եք ${user}֊ի հետ`
        },
        tr_sending: "Ուղարկվում է",
        tr_send: "Ուղարկել",
        tr_chooseFile: "Ընրտել ֆայլ",
        tr_notConnected: "Կապը դեռ հաստատված չէ",
        tr_waitingForAccept(user){ return `Սպասում ենք ${user} օգտատիրոջ պատասխանին ...` },
        tr_declined(user){ return `${user} օգտատերը մերժեց հարցումը` },
        tr_noAnswer(user){ return `${user} օգտատերը չպատասխանեց` },
        tr_incomingTitle: "Ֆայլերի փոխանակման հարցում",
        tr_incomingRequest(user){ return `${user} օգտատերը ցանկանում է Ձեզ ֆայլեր ուղարկել անմիջական կապով։ Ընդունե՞լ` },
        tr_accept: "Ընդունել",
        tr_decline: "Մերժել"
    },
    "eng": {
        tr_sucsessfullySent: "File sent successfully",
        tr_error: "Error, try again",
        tr_pleaseWait: "Please wait...",
        tr_isntOnline: "The user is not available",
        tr_connectedWith(user){
            return `You are in contact with ${user}`
        },
        tr_sending: "Sending",
        tr_send: "Send",
        tr_chooseFile: "Choose a file",
        tr_notConnected: "Not connected yet",
        tr_waitingForAccept(user){ return `Waiting for ${user} to accept the request...` },
        tr_declined(user){ return `${user} declined the request` },
        tr_noAnswer(user){ return `${user} did not answer` },
        tr_incomingTitle: "File transfer request",
        tr_incomingRequest(user){ return `${user} wants to send you files over a direct connection. Accept?` },
        tr_accept: "Accept",
        tr_decline: "Decline"
    },
    "fr": {
        tr_sucsessfullySent: "Fichier envoyé avec succès",
        tr_error: "Erreur, réessayez",
        tr_pleaseWait: "S'il vous plaît, attendez...",
        tr_isntOnline: "L'utilisateur n'est pas disponible",
        tr_connectedWith(user){
            return `Vous êtes en contact avec ${user}`
        },
        tr_sending: "Envoi",
        tr_send: "Envoyer",
        tr_chooseFile: "Choisissez un fichier",
        tr_notConnected: "Pas encore connecté",
        tr_waitingForAccept(user){ return `En attente de l'acceptation de ${user}...` },
        tr_declined(user){ return `${user} a refusé la demande` },
        tr_noAnswer(user){ return `${user} n'a pas répondu` },
        tr_incomingTitle: "Demande de transfert de fichiers",
        tr_incomingRequest(user){ return `${user} souhaite vous envoyer des fichiers par connexion directe. Accepter ?` },
        tr_accept: "Accepter",
        tr_decline: "Refuser"
    },
    "arb": {
        tr_sucsessfullySent: "تم إرسال الملف بنجاح",
        tr_error: "خطأ، حاول مرة أخرى",
        tr_pleaseWait: "انتظر من فضلك...",
        tr_isntOnline: "المستخدم غير متوفر",
        tr_connectedWith(user){
            return "أنت على اتصال مع"  + " " + user
        },
        tr_sending: "إرسال",
        tr_send: "يرسل",
        tr_chooseFile: "اختر ملفًا",
        tr_notConnected: "لم يتم الاتصال بعد",
        tr_waitingForAccept(user){ return "في انتظار قبول " + user + " للطلب..." },
        tr_declined(user){ return user + " رفض الطلب" },
        tr_noAnswer(user){ return user + " لم يرد" },
        tr_incomingTitle: "طلب نقل ملفات",
        tr_incomingRequest(user){ return user + " يريد إرسال ملفات إليك عبر اتصال مباشر. هل تقبل؟" },
        tr_accept: "قبول",
        tr_decline: "رفض"
    },
    "rus": {
        tr_sucsessfullySent: "Файл успешно отправлен",
        tr_error: "Ошибка, попробуйте ещё раз",
        tr_pleaseWait: "Пожалуйста, подождите...",
        tr_isntOnline: "Пользователь недоступен",
        tr_connectedWith(user) { return `Вы на связи с пользователем ${user}` },
        tr_sending: "Отправка",
        tr_send: "Отправить",
        tr_chooseFile: "Выбрать файл",
        tr_notConnected: "Соединение ещё не установлено",
        tr_waitingForAccept(user) { return `Ожидаем, пока ${user} примет запрос...` },
        tr_declined(user) { return `${user} отклонил(а) запрос` },
        tr_noAnswer(user) { return `${user} не ответил(а)` },
        tr_incomingTitle: "Запрос на передачу файлов",
        tr_incomingRequest(user) { return `${user} хочет отправить вам файлы по прямому соединению. Принять?` },
        tr_accept: "Принять",
        tr_decline: "Отклонить",
    }
}